'use strict';

require('./GridItemWithFilter.scss');

const React = require('react'),
    {PropTypes} = require('react'),
    GridItem = require('./GridItem'),
    {cloneDeep} = require('lodash/lang'),
    {filter, map, orderBy} = require('lodash/collection'),
    get = require('lodash/object').get,
    ContentUtils = require('utils/ContentUtils'),
    GridItemFilter = require('./GridItemFilter');

const GridItemWithFilter = React.createClass({displayName: "GridItemWithFilter",

    propTypes: {
        label: PropTypes.string,
        isCheckedItem: PropTypes.func,
        isChangedItem: PropTypes.func,
        items: PropTypes.array,
        onCheckItem: PropTypes.func,
        initialFilterText: PropTypes.string,
        nonMatchingText: PropTypes.string,
        displayNameField: PropTypes.string,
        iconInnerText: PropTypes.string,
        iconClassNameField: PropTypes.string,
        idField: PropTypes.string,
        filterHidden: PropTypes.bool,
        keepSelectedSorting: PropTypes.bool,
        dictionary: PropTypes.object
    },

    getInitialState() {
        return {
            filterText: null,
            isPristine: true
        };
    },

    _onKeyDownFilter(evt) {
        const haveSomeTextToFilter = evt && evt.target;
        const haveEmptyText = evt && evt.target === '';

        if (haveSomeTextToFilter || haveEmptyText) {
            const filterText = evt.target.value;
            this.setState({
                filterText,
                isPristine: false
            });
        }
    },

    _filterItems(items, filterText) {
        const safeItems = cloneDeep(items);
        if (!filterText) {
            return items;
        }

        const {isChangedItem, displayNameField, idField} = this.props;
        const filteredItems = filter(safeItems, item => {
            const label = get(item, displayNameField) || '';
            return label.toLowerCase().includes(filterText.toLowerCase()) || (isChangedItem ? isChangedItem(item) : false);
        });

        return ContentUtils.removeDuplicateByAttribute(filteredItems, idField);
    },

    _onCheck(gridItemProps) {
        if (this.props.onCheckItem) {
            this.props.onCheckItem(gridItemProps, this._getCurrentTextFilter());
        }
    },

    _getCurrentTextFilter() {
        const {initialFilterText} = this.props;
        const {isPristine, filterText} = this.state;

        if (filterText) {
            return filterText;
        }

        if (isPristine && initialFilterText) {
            return initialFilterText;
        }

        return ''; // non-filter
    },

    _sortedItems(items) {
        return ContentUtils.sortList(items || [], this.props.displayNameField);
    },

    render() {
        const {
            keepSelectedSorting,
            isCheckedItem,
            isChangedItem,
            items,
            nonMatchingText,
            displayNameField,
            iconClassNameField,
            filterHidden,
            label,
            iconInnerText,
            dictionary
        } = this.props;
        const finalFilterText = this._getCurrentTextFilter();
        const sortedItems = this._sortedItems(items);
        const itemsFiltered = this._filterItems(sortedItems, finalFilterText);

        const isEmptyItems = ContentUtils.isEmptyArray(itemsFiltered);
        const filterEl = filterHidden === true ? null : (
            React.createElement(GridItemFilter, {
                value: this._getCurrentTextFilter(), 
                onChange: this._onKeyDownFilter, 
                onBlur: this._onKeyDownFilter}
            )
        );
        if (isEmptyItems) {
            return (
                React.createElement("div", {className: "bp-grid-item-withfilter"}, 
                    filterEl, 
                    React.createElement("div", {style: {
                        backgroundColor: 'gray',
                        textAlign: 'center',
                        background: 'white',
                        fontSize: '20px'
                    }}, 
                        React.createElement("p", null, nonMatchingText)
                    )
                )
            );
        }

        const itemsFilteredSorted = keepSelectedSorting ?  orderBy(itemsFiltered, isCheckedItem, ['desc']) : itemsFiltered;
        const itemsFilteredAndExtraSorted = keepSelectedSorting ? itemsFilteredSorted : ContentUtils.sortIcons(itemsFilteredSorted);
        const GridItemsEl = map(itemsFilteredAndExtraSorted, item => {
                const label = dictionary ? dictionary[item.name] || `[${get(item, displayNameField)}]` : get(item, displayNameField);
                const iconClass = get(item, iconClassNameField);
                const iconInnerTextValue = get(item, iconInnerText);
                const isChecked = isCheckedItem(item);
                const isIconChanged = isChangedItem(item);

                return (
                    React.createElement(GridItem, {
                        iconId: get(item, 'id'), 
                        label: label, 
                        iconClassName: iconClass, 
                        iconInnerText: iconInnerTextValue, 
                        isChecked: isChecked, 
                        className: isIconChanged ? 'is-changed' : undefined, 
                        onCheck: this._onCheck}
                    )
                );
            }
        );

        return (
            React.createElement("div", {className: "bp-grid-item-withfilter"}, 
                React.createElement("h2", null, label ), 
                filterEl, 
                GridItemsEl 
            )
        );
    }

});


module.exports = GridItemWithFilter;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/GridItem/GridItemWithFilter.js
 **/